import React from 'react';

const SectionH1 = ({ title }) => {
    return (
        <h1 class="font-syne-bold mb-4 sm:mb-8 text-4xl tracking-tight leading-none text-white md:text-5xl lg:text-6xl">{title}</h1>
    );
};

export default SectionH1;